
import { defineComponent, PropType } from 'vue'
import draggable from 'vuedraggable'
import { EyeOutlined, EyeInvisibleOutlined, LockOutlined, UnlockOutlined, DragOutlined } from '@ant-design/icons-vue'
import { ComponentData } from '../store/editor'
import InlineEdit from '../components/InlineEdit.vue'
export default defineComponent({
  components: {
    EyeOutlined,
    EyeInvisibleOutlined,
    LockOutlined,
    UnlockOutlined,
    InlineEdit,
    draggable,
    DragOutlined
  },
  props: {
    list: {
      type: Array as PropType<ComponentData[]>,
      required: true
    },
    selectedId: {
      type: String,
      required: true
    }
  },
  emits: ['select', 'change', 'drop'],
  setup(props, context) {
    const handleClick = (id: string) => {
      context.emit('select', id)
    }
    const handleChange = (id: string, key: string, value: boolean) => {
      const data = {
        id,
        key,
        value,
        isRoot: true
      }
      context.emit('change', data)
    }
    return {
      handleChange,
      handleClick
    }
  }
})
